import React from 'react';
import { Plug } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BrandMark, type BrandKey } from './ui/BrandLogos';

type Tool = { label: string; brand?: BrandKey };

const rowA: Tool[] = [
    { label: 'n8n', brand: 'n8n' },
    { label: 'Make', brand: 'make' },
    { label: 'Zapier', brand: 'zapier' },
    { label: 'OpenAI', brand: 'openai' },
    { label: 'Claude', brand: 'claude' },
    { label: 'Anthropic', brand: 'anthropic' },
    { label: 'HubSpot', brand: 'hubspot' },
    { label: 'Salesforce', brand: 'salesforce' },
    { label: 'Shopify', brand: 'shopify' },
    { label: 'Airtable', brand: 'airtable' },
    { label: 'Notion', brand: 'notion' },
];

const rowB: Tool[] = [
    { label: 'WhatsApp', brand: 'whatsapp' },
    { label: 'Twilio', brand: 'twilio' },
    { label: 'Slack', brand: 'slack' },
    { label: 'Google Sheets', brand: 'googleSheets' },
    { label: 'Supabase', brand: 'supabase' },
    { label: 'Stripe', brand: 'stripe' },
    { label: 'Gmail', brand: 'gmail' },
    { label: 'Telegram', brand: 'telegram' },
    { label: 'PostgreSQL', brand: 'postgresql' },
    { label: 'Pipedrive' },
];

const Pill: React.FC<Tool> = ({ label, brand }) => (
    <span className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-xl bg-white/[0.03] border border-white/[0.06] px-5 py-3 text-text-main font-medium hover:border-brand-cyan/40 hover:text-white transition-colors">
        {brand ? (
            <BrandMark brand={brand} className="w-[18px] h-[18px]" />
        ) : (
            <span className="w-1.5 h-1.5 rounded-full bg-brand-cyan/70" />
        )}
        {label}
    </span>
);

const Marquee: React.FC<{ items: Tool[]; reverse?: boolean }> = ({ items, reverse }) => (
    <div className="relative overflow-hidden marquee-hover-pause [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div
            className={`flex w-max gap-4 ${reverse ? 'animate-marquee-slow [animation-direction:reverse]' : 'animate-marquee'}`}
        >
            {[...items, ...items].map((item, i) => (
                <Pill key={`${item.label}-${i}`} {...item} />
            ))}
        </div>
    </div>
);

const Integrations: React.FC = () => {
    return (
        <section className="relative py-24 md:py-28 overflow-hidden">
            <div className="container-x">
                <Reveal className="text-center max-w-2xl mx-auto mb-12">
                    <span className="eyebrow mb-4 justify-center">
                        <Plug className="w-4 h-4" /> Integrations
                    </span>
                    <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight">
                        Works with <span className="text-gradient">your entire stack</span>
                    </h2>
                    <p className="mt-4 text-text-muted text-lg">
                        We connect the tools you already use — and the 5,000+ others you might. If it has an API, we can automate it.
                    </p>
                </Reveal>
            </div>

            <div className="space-y-4">
                <Marquee items={rowA} />
                <Marquee items={rowB} reverse />
            </div>
        </section>
    );
};

export default Integrations;
